"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableReportTypes = exports.ReportsByGroup = exports.isReportQueryType = exports.ReportTypes = exports.ReportFunctionTypes = exports.ReportQueryTypes = void 0;
exports.ReportQueryTypes = [
    "monthly_shows",
    "yearly_shows",
    "artists",
    "setlive_shows_scheduled_monthly",
    "setlive_shows_added_monthly",
    "setbio",
    "setfan",
    "setfan_responses_monthly",
    "setfan_profiling_monthly",
    "setfan_recent",
    "setlive_shows_scheduled_year",
    "setlive_recent",
    "setlive_upcoming",
    "setlive_scheduled",
    "setlive_added",
    "setlive_usage",
    "setlive_early_usage",
    "brand_preferences",
    "presave_summary",
    "last_updated_at",
    "integration_sync_summary",
    "integration_sync_errors_by_artist_group",
    "forward_looking_inventory",
    "artists_added_by_month",
    "set_shows_scheduled_by_month",
    "set_live_entries_by_month",
    "set_fan_entries_by_month",
];
exports.ReportFunctionTypes = ["user_lookup"];
exports.ReportTypes = [
    ...exports.ReportQueryTypes,
    ...exports.ReportFunctionTypes,
];
const isReportQueryType = (reportType) => {
    return exports.ReportQueryTypes.includes(reportType);
};
exports.isReportQueryType = isReportQueryType;
exports.ReportsByGroup = {
    admin: [...exports.ReportTypes],
    executive: ["last_updated_at"],
    finance: [
        "artists_added_by_month",
        "set_shows_scheduled_by_month",
        "set_live_entries_by_month",
        "set_fan_entries_by_month",
        "last_updated_at",
    ],
};
const getAvailableReportTypes = (superAdmin, groups) => {
    if (superAdmin) {
        return [...exports.ReportTypes];
    }
    // pull all reports for groups and dedupe
    const typesForGroups = groups.flatMap((group) => exports.ReportsByGroup[group]);
    return Array.from(new Set(typesForGroups));
};
exports.getAvailableReportTypes = getAvailableReportTypes;
//# sourceMappingURL=index.js.map